import React from 'react';
import { connect } from 'react-redux';
import { fetchTimeLineModel } from './TimeLineBlock.action';
import TimeLineBlock from './TimeLineBlock';

class TimeLineBlockContainer extends React.Component {
    constructor(props) {
        super(props);
        this.props.fetchData(this.props.blockId);
    }
    render() {
        return (
            <TimeLineBlock {...this.props} />
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchData: (blockId) => dispatch(fetchTimeLineModel(blockId))
    }

}
const mapStateToProps = state => {
    return {
        result: state.TimeLineReducer.result,
        innerWidth: state.browserSize.innerWidth,
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(TimeLineBlockContainer);